module.exports = __webpack_public_path__ + "3365bfe95112b3d59f011ae52aaba26e.MP3";